import { IConfigurations } from '@epicuro-next/platform/configuration';

import {
  IOrderDetailActionTypes,
  OrderDetailFieldProps,
  OrderDetailFilterIds,
  OrderDetailSizeGridRowName,
  OrderDetailTableProps,
  SizeGridRowConfig,
} from './models';

export const ORDER_BOOK_NAMESPACE = 'order-book';

export enum OrderBookConfigurationKeys {
  isEnabled = 'is-enabled',
  detailProperties = 'detail-properties',
  detailDeliveryLinkEnabled = 'detail-delivery-link-enabled',
  detailInvoiceLinkEnabled = 'detail-invoice-link-enabled',
  listProperties = 'list-properties',
  exportOrders = 'export-orders-xls',
  exportAllOrders = 'export-all-orders-xls',
  filterYearEnabled = 'filter-year-enabled',
  numberProperties = 'number-properties',
  invoicesDropdown = 'invoices-dropdown',
  orderDetailActions = 'order-detail-actions',
  showStatusTooltips = 'show-status-tooltips',
  detailSizeGridRows = 'detail-size-grid-rows',
  columnsWithTooltip = 'columns-with-tooltip',
  futureDeliveryFormat = 'future-delivery-format',
  isAccountFilterEnabled = 'is-account-filter-enabled',
  invoicesTableSchema = 'invoices-table-schema',
  orderListTableSchema = 'order-list-table-schema',
  orderDetailsSchema = 'order-details-schema',
  paginationPageSize = 'pagination-page-size',
  paginationEnabled = 'pagination-enabled',
  showOrdersAmount = 'show-orders-amount',
  showFallbackForEmptyValue = 'show-fallback-for-empty-value',
  useDeliveryNoteUrl = 'use-delivery-note-url',
  pageFooterEnabled = 'order-book-page-footer',
  orderDetailsFilters = 'order-details-filters',
  orderDetailsSearchProperties = 'order-details-search',
  expandAllDetailLinesButton = 'expand-all-detail-lines-button',
  showUnconfirmedQuantity = 'show-unconfirmed-quantity',
}

export interface OrderBookDetailProperties {
  fields: {
    mandatory: string[];
    configurable: string[];
  };
  columns: string[];
  more: string[];
  variants: string[];
  productTitle?: string[];
  footer?: string[];
}

export interface OrderBookConfigurations
  extends IConfigurations<OrderBookConfigurationKeys> {
  [OrderBookConfigurationKeys.isEnabled]: boolean;
  [OrderBookConfigurationKeys.detailProperties]: OrderBookDetailProperties;
  [OrderBookConfigurationKeys.detailDeliveryLinkEnabled]: boolean;
  [OrderBookConfigurationKeys.detailInvoiceLinkEnabled]: boolean;
  [OrderBookConfigurationKeys.listProperties]: string[];
  [OrderBookConfigurationKeys.numberProperties]: string[];
  [OrderBookConfigurationKeys.exportOrders]: boolean;
  [OrderBookConfigurationKeys.exportAllOrders]: boolean;
  [OrderBookConfigurationKeys.filterYearEnabled]: boolean;
  [OrderBookConfigurationKeys.invoicesDropdown]: boolean;
  [OrderBookConfigurationKeys.isAccountFilterEnabled]: boolean;
  [OrderBookConfigurationKeys.invoicesTableSchema]: string;
  [OrderBookConfigurationKeys.orderDetailActions]: IOrderDetailActionTypes[];
  [OrderBookConfigurationKeys.orderListTableSchema]: string;
  [OrderBookConfigurationKeys.orderDetailsSchema]: string;
  [OrderBookConfigurationKeys.futureDeliveryFormat]: string;
  [OrderBookConfigurationKeys.showStatusTooltips]: boolean;
  [OrderBookConfigurationKeys.columnsWithTooltip]: (
    | OrderDetailTableProps
    | OrderDetailFieldProps
  )[];
  [OrderBookConfigurationKeys.paginationPageSize]: number;
  [OrderBookConfigurationKeys.paginationEnabled]: boolean;
  [OrderBookConfigurationKeys.showOrdersAmount]: boolean;
  [OrderBookConfigurationKeys.showFallbackForEmptyValue]: boolean;
  [OrderBookConfigurationKeys.useDeliveryNoteUrl]: boolean;
  [OrderBookConfigurationKeys.orderDetailsFilters]: OrderDetailFilterIds[];
  [OrderBookConfigurationKeys.orderDetailsSearchProperties]: string[];
  [OrderBookConfigurationKeys.expandAllDetailLinesButton]: string[];
  [OrderBookConfigurationKeys.detailSizeGridRows]: SizeGridRowConfig[];
  [OrderBookConfigurationKeys.showUnconfirmedQuantity]: boolean;
}

export const DEFAULT_IS_ENABLED_ORDER_BOOK_RULE = true;

export const FILTER_YEAR_CONFIG = {
  namespace: ORDER_BOOK_NAMESPACE,
  featureName: OrderBookConfigurationKeys.filterYearEnabled,
  defaultValue: false,
};

export const PAGINATION_CONFIG = {
  namespace: ORDER_BOOK_NAMESPACE,
  featureName: OrderBookConfigurationKeys.paginationPageSize,
  defaultValue: 25,
};

export const SIZE_GRID_ROWS_CONFIG_DEFAULT = [
  {
    rowId: OrderDetailSizeGridRowName.Count,
    pathToSizeProperty: 'count',
  },
];
